/**
 * Product Endpoint - placeholder for product-related endpoints
 * Can be expanded with specific product types as needed
 */

import { DreamscapeClient } from '../client';
import { Product, Collection } from '../types';

export class ProductEndpoint {
  constructor(private client: DreamscapeClient) {}

  /**
   * Get all products (placeholder - expand as needed)
   */
  async getAll(filters?: { page?: number; limit?: number }): Promise<Collection<Product>> {
    const params: Record<string, any> = {};
    if (filters?.page) params.page = filters.page;
    if (filters?.limit) params.limit = filters.limit;

    return this.client.request<Collection<Product>>('GET', 'products', undefined, params);
  }
}

